var map = {
	"./app.svg": 544,
	"./badge.svg": 74,
	"./football.svg": 545,
	"./pennant.svg": 123,
	"./player.svg": 146,
	"./printer.svg": 546,
	"./referee.svg": 547,
	"./score.svg": 548,
	"./tour.svg": 549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 543;